exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1TUJJxSa1_avnDaIC8uEjX{width:300px}html[dir] ._1TUJJxSa1_avnDaIC8uEjX{background-color:\"[theme:white, default:#ffffff]\"}._1LOZ5u3QWcz2YtiHCb4gZl{-webkit-animation:none!important;animation:none!important}._2mbQIMyI87JezYkvODT3iX{max-height:470px;overflow-x:hidden}._2Kz4dRQsi4N_6yjH1XPpB3{height:30px}html[dir=ltr] ._2Kz4dRQsi4N_6yjH1XPpB3{padding-left:12px}html[dir=rtl] ._2Kz4dRQsi4N_6yjH1XPpB3{padding-right:12px}._1xQwhfxZb_s4vRC-hCLX4d{font-size:12px;font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";line-height:1;display:inline-block}html[dir] ._1xQwhfxZb_s4vRC-hCLX4d{padding-top:8px}", ""]);

// exports
exports.locals = {
	"callout": "_1TUJJxSa1_avnDaIC8uEjX",
	"animationStop": "_1LOZ5u3QWcz2YtiHCb4gZl",
	"scrollContainer": "_2mbQIMyI87JezYkvODT3iX",
	"suggestedContactsHeaderBox": "_2Kz4dRQsi4N_6yjH1XPpB3",
	"suggestedContactsText": "_1xQwhfxZb_s4vRC-hCLX4d"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/owa-contact-picker/lib/components/ContactPickerPane.scss
// module id = 5208
// module chunks = 99